import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import styles from "./PluginsMetaTab.module.css";
import Card from "shared/Card";
import SearchBar from "DreamStream/Shared/SearchBar";
import MetaPluginsList from "./MetaPluginsList";
import classNames from "classnames";
import { usePlugins } from "../usePlugins";
import Loader from "shared/Loader";

export function PluginsMetaTab({ plugins }) {
  // console.log("*** plugins ***");
  // console.log(plugins);
  // console.log("********************");

  const { data, error, loading } = usePlugins();

  const [allPlugins, setAllPlugins] = useState(plugins);
  const [currentPlugins, setCurrentPlugins] = useState(allPlugins);
  // const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  // const [viewedPlugin, setViewedPlugin] = useState(null);

  function addPlugin(baseGroup, addGroup) {
    let pluginsCount = allPlugins.length;

    let nowDate = new Date();
    let date =
      nowDate.getFullYear() +
      "/" +
      (nowDate.getMonth() + 1) +
      "/" +
      nowDate.getDate();
    let time =
      nowDate.getHours() +
      ":" +
      nowDate.getMinutes() +
      ":" +
      nowDate.getSeconds();

    pluginsCount += 1;

    let newPlugin = {
      id: pluginsCount,
      baseGroup: baseGroup,
      addGroup: addGroup,
      date: date,
      time: time,
    };

    setAllPlugins((allPlugins) => [...allPlugins, newPlugin]);
    setCurrentPlugins((currentPlugins) => [...currentPlugins, newPlugin]);
    // setIsAddModalOpen(false);
  }

  const [sortedPlugins, setSortedPlugins] = useState([]);

  useEffect(() => {
    if (plugins) {
      setSortedPlugins(plugins);
    }
  }, [plugins]);

  const onSearch = (searchText) => {
    const searchWords = searchText.trim().toLowerCase().split(/\s+/);

    const newSort =
      searchText.length > 0
        ? plugins.filter((plugin) => {
            return searchWords.every(
              (word) =>
                String(plugin.plugeeIBONumber).includes(word) ||
                String(plugin.targetIBONumber).includes(word) ||
                String(plugin.plugeeBusinessType).includes(word) ||
                String(plugin.plugeeOrganizationName)
                  .toLowerCase()
                  .includes(word) ||
                String(plugin.targetGroupName).toLowerCase().includes(word) ||
                String(plugin.targetOrganizationName)
                  .toLowerCase()
                  .includes(word)
            );
          })
        : plugins;
    setSortedPlugins(newSort);
  };

  return (
    <>
      <div className={styles.subHeader}>
        Meta Plugins in used to <strong>ADD</strong> all IBOs in one DreamStream
        Group (Plugin Group) into a different DreamStream Group (Target Group).
        The IBOs added will see both DreamStream groups.
      </div>
      <Card className={styles.cardContainer}>
        <div className={styles.header}>Meta Plugins</div>
        <SearchBar
          onInput={(value) => onSearch(value)}
          placeholderText="Search by IBO, Organization Name, or Group Name"
          searchDelay={0}
          minChar={0}
          className={styles["search-bar"]}
          btn={true}
        />
        {loading ? (
          <Loader />
        ) : (
          <>
            <MetaPluginsList plugins={sortedPlugins} />
          </>
        )}
      </Card>
    </>
  );
}
